
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UtilsService } from '../service/utils.service';
import { AuthService } from '../service/auth.service';
import 'rxjs/add/operator/toPromise';
@Injectable()

export class HttpService {

  constructor(private http: HttpClient, private utils: UtilsService, private authService: AuthService) { }
  getOptions() {
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    headers.set('SkipLoader', 'yes');
    return { headers: headers, skip: true };
  }

  post(url: any, obj: any) {

    const promise = new Promise((resolve, reject) => {
      this.authService.refreshToken().then(result => {
        if (result) {
          this.http.post(url, obj, this.getOptions())
            .toPromise()
            .then(
            responseJson => {
              resolve({ receiveObj: responseJson, success: true });
            }
            ).catch(error => {
              resolve({ receiveObj: error, success: false });
            });
        } else {
          resolve({ receiveObj: 'error', success: false });
        }
      })
        .catch(error => {
          resolve({ receiveObj: error, success: false });
        });
    });

    return promise;
  }

  get(url: any) {
    const promise = new Promise((resolve, reject) => {
      this.authService.refreshToken().then(result => {
        if (result) {
          this.http.get(url, this.getOptions())
            .toPromise()
            .then(
            responseJson => { // Success
              resolve({ receiveObj: responseJson, success: true });
            }
            ).catch(error => {
              resolve({ receiveObj: error, success: false });
            });
        } else {
          resolve({ receiveObj: 'error', success: false });
        }
      })
        .catch(error => {
          resolve({ receiveObj: error, success: false });
        });
    });

    return promise;
  }

  getWithParm(url: any) {
    const promise = new Promise((resolve, reject) => {
      this.authService.refreshToken().then(result => {
        if (result) {
          this.http.get(url, this.getOptions())
            .toPromise()
            .then(
            responseJson => { // Success
              resolve({ receiveObj: responseJson, success: true });
            }
            ).catch(error => {
              resolve({ receiveObj: error, success: false });
            });
        } else {
          resolve({ receiveObj: 'error', success: false });
        }
      })
        .catch(error => {
          resolve({ receiveObj: error, success: false });
        });

    });

    return promise;
  }

  put(url: any, obj: any) {
    const promise = new Promise((resolve, reject) => {

      this.authService.refreshToken().then(result => {
        if (result) {
          this.http.put(url, obj, this.getOptions())
            .toPromise()
            .then(
            responseJson => {
              resolve({ receiveObj: responseJson, success: true });
            }
            ).catch(error => {
              resolve({ receiveObj: error, success: false });
            });
        } else {
          resolve({ receiveObj: 'error', success: false });
        }
      })
        .catch(error => {
          resolve({ receiveObj: error, success: false });
        });
    });

    return promise;
  }

  delete(url: any) {
    const promise = new Promise((resolve, reject) => {

      this.authService.refreshToken().then(result => {
        if (result) {
          this.http.delete(url, this.getOptions())
            .toPromise()
            .then(
            responseJson => { // Success
              resolve({ receiveObj: responseJson, success: true });
            }
            ).catch(error => {
              resolve({ receiveObj: error, success: false });
            });
        } else {
          resolve({ receiveObj: 'error', success: false });
        }
      })
        .catch(error => {
          resolve({ receiveObj: error, success: false });
        });
    });

    return promise;
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/service/http.service.ts